<div #trapContainer style="height: 100vh;overflow: hidden;">

  <app-page-loader></app-page-loader>
  @if (isLoading | async) {
    <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
  }
  <router-outlet></router-outlet>

</div>